import { useRef } from 'react'
import BizestCancelResultPage from './page.generated'
import { resetBizestCancelStore } from './wiring'

/**
 * GI17 출고취소(비제스트) 2.0 — 화면은 컨덕터 생성본(page.generated.tsx), 배선은 wiring.ts (LOGISPRD-16035).
 * 조회 전용이다. 1.0 GI17(iframe)은 그대로 두고 새 메뉴코드로 나란히 올린다.
 */
export default function BizestCancelResult() {
  // 모듈 상태(조회 조건)는 첫 렌더 전에 비운다 — 탭을 다시 열면 빈 화면에서 시작한다.
  const initialized = useRef(false)
  if (!initialized.current) {
    initialized.current = true
    resetBizestCancelStore()
  }
  return <BizestCancelResultPage />
}
